import React from "react";
import styled from "styled-components";
import "bulma/css/bulma.css";

const HeroContent = () => {
  return (
    <DivConten>
      <H2 className=" ">
        Hi! I'm Joaquin. <br /> Fullstack Web Developer
      </H2>
    </DivConten>
  );
};

const DivConten = styled.div`
  width: 53%;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 80%;
  }
`;
const H2 = styled.h2`
  color: white;
  font-weight: 400;
  text-align: left;
  font-size: 2.9rem;
  max-width: 80%;
  text-shadow: 2px 4px 4px black;

  @media (max-width: 968px) {
    max-width: 100%;
    font-size: 2rem;
  }
`;
export default HeroContent;
